const makeHtmlSafe = (text) => {
    return text
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('\n', '<br />')
        .replaceAll('\t', '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
}

const createParagraphs = (text) => {
    return text
        .split('<br/>').join('<br />')
        .split('<br>').join('<br />')
        .split('<br />')
        .map(x => `<p>${x}</p>`)
        .join('');
}

export const HTML = ({text, id, className, doCreateParagraphs}) => {
    text = makeHtmlSafe(text);
    text = doCreateParagraphs ? createParagraphs(text) : text;

    return (
        <div
            id={id ? id : ''}
            className={className ? className : ''}
            dangerouslySetInnerHTML={{ __html: text }}
        />
    );
}